import { JointShape } from '@/modules/ConfiguratorJoints/composables/useShapeAndAngle';
import { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';
import {
    baseExternalCanvasTemplate,
    baseInternalCanvasTemplate,
} from '@/modules/ConfiguratorJoints/helpers/baseTemplateConfig';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const concealedGuideBottomUrl: string = require('@/modules/ConfiguratorJoints/assets/hero-3-concealed-guide-bottom.png');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const concealedGuideTopUrl: string = require('@/modules/ConfiguratorJoints/assets/hero-3-concealed-guide-top.png');

export const externalCanvasTemplate: JointCanvasTemplateConfiguration = {
    ...baseExternalCanvasTemplate,
    pivotGlobalConfiguration: {
        ...baseExternalCanvasTemplate.pivotGlobalConfiguration,
        concealedGuideOneLeftArmX: -65,
        concealedGuideOneLeftArmY: -36,
        concealedGuideOneLeftArmRotation: 270,
        concealedGuideTwoLeftArmX: -185,
        concealedGuideTwoLeftArmY: -77,
        concealedGuideTwoLeftArmRotation: 90,
        concealedGuideOneRightArmX: 33,
        concealedGuideOneRightArmY: 145,
        concealedGuideOneRightArmRotation: 0,
        concealedGuideTwoRightArmX: 74,
        concealedGuideTwoRightArmY: 25,
        concealedGuideTwoRightArmRotation: 180,
    },
    guides: {
        ...baseExternalCanvasTemplate.guides!,
        concealedGuideBottom: {
            url: concealedGuideBottomUrl,
            widthMm: 10.3875688,
            heightMm: 2.0390701,
        },
        concealedGuideTop: {
            url: concealedGuideTopUrl,
            widthMm: 10.4327766,
            heightMm: 2.0480919,
        },
    },
};

export const internalCanvasTemplate: JointCanvasTemplateConfiguration = {
    ...baseInternalCanvasTemplate,
    pivotGlobalConfiguration: {
        ...baseInternalCanvasTemplate.pivotGlobalConfiguration,
        concealedGuideOneLeftArmX: -42,
        concealedGuideOneLeftArmY: -8,
        concealedGuideOneLeftArmRotation: 0,
        concealedGuideTwoLeftArmX: -1,
        concealedGuideTwoLeftArmY: -128,
        concealedGuideTwoLeftArmRotation: 180,
        concealedGuideOneRightArmX: 168,
        concealedGuideOneRightArmY: 43,
        concealedGuideOneRightArmRotation: 270,
        concealedGuideTwoRightArmX: 50,
        concealedGuideTwoRightArmY: 1,
        concealedGuideTwoRightArmRotation: 90,
    },
    guides: {
        ...baseInternalCanvasTemplate.guides!,
        concealedGuideBottom: {
            url: concealedGuideBottomUrl,
            widthMm: 10.3875688,
            heightMm: 2.0390701,
        },
        concealedGuideTop: {
            url: concealedGuideTopUrl,
            widthMm: 10.4327766,
            heightMm: 2.0480919,
        },
    },
};

export const heroThreeJointCanvasTemplate: Record<JointShape, JointCanvasTemplateConfiguration> = {
    external: externalCanvasTemplate,
    internal: internalCanvasTemplate,
};
